<template>
	<GmapPolygon
		v-if="paths.length !== 0"
		:editable="editable"
		:options="options"
		:paths="paths"
		@click="handleClick"
	/>
</template>

<script>
import { CoordenatesToGooglePattern } from '../../utils/MapFunctions'
export default {
	props: {
		/**
		 * Permite a edição de shape
		 */
		evento: Object,
		properties: {
			type: Object,
		},
		editable: {
			type: Boolean,
			default: false,
		},
		/**
		 * Estilizacao e opções do google maps para poligonos
		 * @Documentation https://developers.google.com/maps/documentation/javascript/reference/polygon#PolygonOptions
		 */
		options: Object,
		/**
		 * Geojson do shape que está sendo exibido
		 */
		coordinates: Array,
		/**
		 * Multipoligono ou Poligono
		 */
		type: String,
	},
	data() {
		return {
			paths: [],
			count: 0,
		}
	},
	watch: {
		/**
		 * Qualquer mudanca no geojson vai ser recriado o shape para o padrão do Google Maps
		 */
		coordinates: {
			handler: function (newValue) {
				this.paths = CoordenatesToGooglePattern(newValue, this.type)
			},
			immediate: true,
		},
	},
	methods: {
		handleClick(e) {
			if (this.properties.idPlantio)
				this.$emit('click', Object.assign(e, { id: this.properties.idPlantio }))
			else this.$emit('click', Object.assign(e, { properties: this.properties }))
		},
	},
}
</script>

<style scoped></style>
